module.exports = __webpack_public_path__ + "img/1557614056671617026.7cd451ad.png";